<template>
  <div class="cmp_list_cla">
    <zk-table
      ref="table"
      :columns="columnData"
      :data="tableData"
      @rowClick="rowClick"
      :headerAlign="'center'"
    ></zk-table>

    <div class="pagination-margin-top">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :pager-count="5"
        @size-change="changePageSize"
        @current-change="changePage"
        :current-page="pager.curPage"
        :page-size="pager.pageSize"
        :total="pager.total"
      ></el-pagination>
    </div>
    <verifyComponent
      :dialogVisible="dialogVisible"
      :checkType="checkType"
      :isEmail="isEmail"
      :title="title"
      :formData="formData"
      :sourceOrgin="sourceOrgin"
      :isChange="isChange"
      @onclose="onclose"
      @submit="submitForm"
    >
      <div style="margin-bottom:15px" slot="tip">
        {{ $t('companyList.deletCompany') }}
      </div>
    </verifyComponent>
  </div>
</template>

<script>
import { findCompanyList, deleteCompany } from '@/services/tenantSettingApi.js'
import verifyComponent from '@/components/verify'
export default {
  data() {
    return {
      params: {
        companyName: '',
        appKey: ''
      },
      tableData: [],
      dialogVisible: false,
      checkType: 'authentication',
      isEmail: false,
      isChange: false,
      sourceOrgin: {
        phone: '',
        email: ''
      },
      formData: {
        code: '',
        phone: '',
        email: ''
      },
      columnData: [
        {
          label: this.$t('header.companyCode'),
          prop: 'companyCode'
        },
        {
          label: this.$t('company.name'),
          prop: 'companyName'
        },

        {
          label: this.$t('device.deviceNum'),
          render: (h, params) => {
            return h('div', {}, [
              h(
                'span',
                {
                  class: {
                    device_num_cla: true
                  }
                },
                `${params.row.devStatusOn}`
              ),
              h('span', {}, `/${params.row.devStatusAll}`)
            ])
          }
        },
        {
          label: this.$t('common.operation'),
          render: (h, params) => {
            let _self = this
            return h('ZkButtonGroup', {
              props: {
                showText: true,
                size: 'mini',
                isGroup: true,
                groupName: 'companyOperation',
                params: params.row,
                onlyShowText: true
              },
              attrs: {
                class: 'zkbutton-delete'
              },
              on: {
                deleteCompany() {
                  _self.deleteCompany(params.row)
                },
                detailCompany() {
                  _self.detailCompany(params.row)
                }
              }
            })
          }
        }
      ],
      searchParams: {}
    }
  },

  mounted() {
    this.showLoad()
    this.$nextTick(() => {
      let _self = this
      let t = setTimeout(() => {
        _self.commQuery()
        _self.closeLoad()
        clearTimeout(t)
      }, 500)
    })
  },
  methods: {
    detailCompany(row) {
      let companyDetail = {
        companyId: row.id,
        companyManagerOn: row.companyManagerOn
      }
      sessionStorage.setItem('companyDetail', JSON.stringify(companyDetail))
      this.$router.push({
        path: `/tenantManager/companyDetails`
        // name: 'companyDetails',
        // params: {
        //   companyId: row.id,
        //   comanyManagerOn: row.companyManagerOn
        // }
      })
    },
    onclose() {
      this.dialogVisible = false
    },
    submitForm(obj) {
      let params = {
        companyId: this.row.id,
        code: obj.code,
        loginName: obj.loginName
      }
      this.showLoad()
      deleteCompany(params)
        .then(data => {
          if (data.code === '00000000') {
            this.onclose()
            this.$message.success(this.$t('operationMsg.deleteSuc'))
            this.commQuery()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
        .finally(() => this.closeLoad())
    },
    deleteCompany(row) {
      let r = [undefined, '']
      if (r.includes(row.appPhone) && r.includes(row.appEmail)) {
        this.$message.warning(this.$t('warningOperation.hasPhoneOrEmail'))
        return false
      }
      this.dialogVisible = true
      this.title = this.$t('common.warningNotice')
      this.row = row
      this.sourceOrgin.phone = row.appPhone
      this.sourceOrgin.email = row.appEmail
      this.formData.phone = this.phoneFormat(row.appPhone) || ''
      this.formData.email = this.emailFormat(row.appEmail) || ''
      if (row.appPhone && row.appEmail) {
        this.isChange = true
        this.isEmail = false
      } else if (row.appPhone && this.isEmptyData(row.appEmail)) {
        this.isChange = false
        this.isEmail = false
      } else if (this.isEmptyData(row.appPhone) && row.appEmail) {
        this.isEmail = true
        this.isChange = false
      }
    },

    changePage(current) {
      this.pager.curPage = current
      let temp = Object.keys(this.searchParams) || []
      if (temp.length !== 0) {
        this.commQuery(this.searchParams)
      } else {
        this.commQuery()
      }
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      let temp = Object.keys(this.searchParams) || []
      if (temp.length !== 0) {
        this.commQuery(this.searchParams)
      } else {
        this.commQuery()
      }
    },
    rowClick(selection) {
      this.$emit('selectRow', selection)
    },
    searchFn(params) {
      this.pager.curPage = 1
      this.searchParams = params
      this.commQuery(params)
    },

    commQuery(params) {
      const role = ['"superadministrator"', '"operator"', '"support"']
      const isAdmin = role.includes(sessionStorage.getItem('role'))

      try {
        this.appKey = this.$route.query.appId // 路由中过来
      } catch (e) {}

      isAdmin && (this.$root.appKey = this.appKey || 'all') // admin || operator

      if (this.$root.appKey === 'noApp') {
        this.$root.appKey = ''
      }
      this.params.appKey = this.$root.appKey // 操作者 开发者

      let finallyParams = {}
      if (params) {
        params.appKey = this.$root.appKey
        finallyParams = Object.assign({}, params)
      } else {
        finallyParams = Object.assign({}, this.params)
      }
      findCompanyList({
        params: finallyParams,
        pager: this.pager
      })
        .then(data => {
          if (data.code === '00000000') {
            const { results, totalRecords, curPage, pageSize } = data.payload
            this.tableData = results
            this.pager.total = totalRecords
            this.pager.curPage = curPage
            this.pager.pageSize = pageSize
            if (this.tableData.length > 0) {
              let item = this.tableData[0]
              this.$emit('selectRow', item)
              this.$refs.table.setCurrentRow(item)
            } else {
              this.$emit('selectRow', null)
            }
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
    }
  },
  components: {
    verifyComponent
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.cmp_list_cla {
  /deep/ .device_num_cla {
    color: @themeColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/companyList.vue